import React, { useState } from 'react';
import './ValidationModal.css'; // Reutilizando os estilos

const InputModal = ({ 
    isOpen, 
    title = "Entrada", 
    message, 
    placeholder = "",
    defaultValue = "",
    confirmText = "Confirmar", 
    cancelText = "Cancelar", 
    onConfirm, 
    onCancel,
    type = "info"
}) => {
    const [inputValue, setInputValue] = useState(defaultValue);

    if (!isOpen) return null;

    const getIcon = () => {
        switch (type) {
            case 'success': return '✅';
            case 'error': return '❌';
            case 'info': return 'ℹ️';
            case 'warning':
            default: return '💾';
        }
    };

    const getHeaderClass = () => {
        switch (type) {
            case 'success': return 'modal-header-success';
            case 'error': return 'modal-header-error';
            case 'info': return 'modal-header-info';
            case 'warning':
            default: return 'modal-header-info';
        }
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onCancel();
        }
    };

    const handleConfirm = () => {
        onConfirm(inputValue.trim());
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && inputValue.trim()) {
            handleConfirm();
        }
    };

    return (
        <div className="validation-modal-backdrop" onClick={handleBackdropClick}>
            <div className="validation-modal confirmation-modal">
                <div className={`validation-modal-header ${getHeaderClass()}`}>
                    <h3>{getIcon()} {title}</h3>
                    <button className="validation-modal-close" onClick={onCancel}>×</button>
                </div>
                
                <div className="validation-modal-content">
                    <p className="validation-modal-description">
                        {message}
                    </p>
                    <input
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyPress={handleKeyPress}
                        placeholder={placeholder}
                        autoFocus
                        style={{
                            width: '100%',
                            padding: '12px',
                            border: '1px solid #ddd',
                            borderRadius: '6px',
                            fontSize: '14px',
                            marginTop: '10px',
                            outline: 'none',
                            boxSizing: 'border-box'
                        }}
                    />
                </div>
                
                <div className="validation-modal-footer">
                    <button 
                        className="validation-modal-button secondary" 
                        onClick={onCancel}
                    >
                        {cancelText}
                    </button>
                    <button 
                        className="validation-modal-button primary" 
                        onClick={handleConfirm}
                        disabled={!inputValue.trim()}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InputModal;
